import {Transport} from "data/transport";
import * as React from "react";
import * as ReactDOM from 'react-dom';
import {ChartModal} from "components/chart/ChartModal";
import {WeeklyLineAndCandleChart} from "components/chart/WeeklyLineAndCandleChart";
import {BarChart} from "components/chart/BarChart";

import './chart.pcss';

export const viewChart = (post) => {

  Transport.GET(`/cmd/postWithFeedItems/${post._id}`)
    .then((data:any)=>{

      // multiple charts
      const charts:Array<any> = [];

      // all of the steps that are type "question" should create a BarGraph
      const questionTypeSteps:Array<any> = [];
      const sliderDailyBarSteps:Array<any> = [];

      let i=0;
      for(i=0;i<post.steps.length;i++) {
        const step = post.steps[i];
        // Slider, weekly, line
        if(('numeric range'==step.type || 'value range'==step.type ) && true==step.showChart && 'line'==step.chartType && 'weekly'==step.chartFrequency) {
          charts.push(<WeeklyLineAndCandleChart key={`graph_${i}`} stepId={step._id} post={data.post} feedItems={data.feedItems} />);
        }
        // question type graphs
        else if('question'==step.type){
          questionTypeSteps.push(step);
        }
        // Slider, Daily, Bar
        else if(('numeric range'==step.type || 'value range'==step.type ) && true==step.showChart &&  'bar'==step.chartType && 'daily'==step.chartFrequency ) {
          sliderDailyBarSteps.push(step);
        }
      }

      // generate a bar chart if there are questionTypeSteps
      if(questionTypeSteps.length>0) {
        charts.push(<BarChart key={`graph_${i}`} steps={questionTypeSteps} feedItems={data.feedItems} />);
      }

      if(sliderDailyBarSteps.length>0) {
        charts.push(<BarChart key={`graph_${i}`} steps={sliderDailyBarSteps} feedItems={data.feedItems} />);
      }

      // render the charts
      ReactDOM.render(<ChartModal title={post.title}>{charts}</ChartModal>, document.getElementById('fullbrowserbody'));

    })
    .catch((reason)=>{
      console.log(reason);
      alert('Failed to load chart!');
    });


}




